import { useEffect, useRef, useState } from "react";
import { useAudience } from "../context/AudienceContext";

export const SegmentedSwitch = ({ size = "md", onChange, testId = "audience-switch" }) => {
  const { audience, setAudience } = useAudience();
  const wrapRef = useRef(null);
  const privateRef = useRef(null);
  const commercialRef = useRef(null);
  const [pill, setPill] = useState({ left: 4, width: 0 });

  const update = () => {
    const wrap = wrapRef.current;
    const target = audience === "privat" ? privateRef.current : commercialRef.current;
    if (!wrap || !target) return;
    const wrapRect = wrap.getBoundingClientRect();
    const tRect = target.getBoundingClientRect();
    setPill({ left: tRect.left - wrapRect.left, width: tRect.width });
  };

  useEffect(() => {
    update();
    const onResize = () => update();
    window.addEventListener("resize", onResize);
    const t = setTimeout(update, 50);
    return () => {
      window.removeEventListener("resize", onResize);
      clearTimeout(t);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audience]);

  const pick = (value) => {
    setAudience(value);
    if (onChange) onChange(value);
  };

  return (
    <div className="segmented" ref={wrapRef} data-testid={testId} style={{ fontSize: size === "lg" ? "14px" : "13px" }}>
      <span className="pill" style={{ left: pill.left, width: pill.width }} aria-hidden />
      <button
        ref={privateRef}
        type="button"
        className={audience === "privat" ? "is-active" : ""}
        onClick={() => pick("privat")}
        data-testid="audience-private-btn"
      >
        Privat
      </button>
      <button
        ref={commercialRef}
        type="button"
        className={audience === "gewerblich" ? "is-active" : ""}
        onClick={() => pick("gewerblich")}
        data-testid="audience-commercial-btn"
      >
        Gewerblich
      </button>
    </div>
  );
};

export default SegmentedSwitch;
